/**
 * Colorway swatches (sibling products) inside a quick-buy modal swap the modal's product in place
 * instead of navigating to the other product's page.
 *
 * Each swatch carries its sibling's variant list, resolved at render time, so switching colorway
 * costs no extra request: the size the shopper already picked is mapped to a variant id locally and
 * the modal can start loading the new colorway immediately.
 *
 * Returns false once the swap is under way, or true to let the link navigate normally (on a product
 * page, or if the embedded data is missing for any reason).
 */
window.waldruhOpenSiblingInQuickBuy = function (link) {
  const modal = link.closest && link.closest('quick-buy-modal');
  if (!modal) return true;

  const handle = link.getAttribute('data-sibling-handle');
  if (!handle) return true;

  let variants = [];
  try {
    variants = JSON.parse(link.getAttribute('data-sibling-variants') || '[]');
  } catch (error) {
    variants = [];
  }
  if (!variants.length) return true;

  const form = modal.querySelector('form');
  let selectedSize = '';
  if (form) {
    const checked =
      form.querySelector('input[data-option-position]:checked') || form.querySelector('input[type="radio"]:checked');
    if (checked && checked.id) {
      const label = modal.querySelector(`label[for="${checked.id}"]`);
      selectedSize = ((label && label.textContent) || '').trim();
    }
  }

  const matchesSize = (variant) => variant.t === selectedSize || (variant.o || []).indexOf(selectedSize) !== -1;
  const variant =
    (selectedSize && variants.find(matchesSize)) || variants.find((candidate) => candidate.a) || variants[0];
  if (!variant || !variant.id) return true;

  modal.setAttribute('handle', `${handle}?variant=${variant.id}`);
  if (typeof modal.show === 'function') modal.show();
  return false;
};

/*
  Delegated from the document: quick buy inserts its content from a DOMParser document, and an
  inline handler attribute on those adopted nodes is never compiled into a handler.
*/
document.addEventListener('click', (event) => {
  const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
  const origin = path[0] && path[0].closest ? path[0] : event.target;
  const swatch = origin && origin.closest ? origin.closest('a[data-sibling-handle]') : null;
  if (!swatch) return;

  if (window.waldruhOpenSiblingInQuickBuy(swatch) === false) event.preventDefault();
});
